import { type ISODateTimeString } from '../BrandedTypes'

export const Support = {
  V1: {
    SupportSessionRegistered: 'Support.V1.SupportSessionRegistered',
    SupportSessionEnded: 'Support.V1.SupportSessionEnded',
    SupportSessionUpdated: 'Support.V1.SupportSessionUpdated'
  }
} as const

export type SupportSessionRegisteredSignalRPayload = {
  sessionId: string
  ownerTenantId: string
  ownerTenantName: string
  requestedByUserId: string
  requestedByFullName: string
  supportPersonUserId: string
  supportPersonFullName: string
  grantedTenantAdmin: boolean
  grantedFrom: ISODateTimeString
  grantedTo: ISODateTimeString
  occuredAt: ISODateTimeString
}

export type SupportSessionEndedSignalRPayload = {
  sessionId: string
  ownerTenantId: string
  ownerTenantName: string
  requestedByUserId: string
  requestedByFullName: string
  supportPersonUserId: null
  supportPersonFullName: string
  durationInSeconds: number
  occuredAt: ISODateTimeString
}

export type SupportSessionUpdatedSignalRPayload = {
  sessionId: string
  ownerTenantId: string
  ownerTenantName: string
  requestedByUserId: string
  requestedByFullName: string
  supportPersonUserId: string
  supportPersonFullName: string
  grantedTenantAdmin: boolean
  grantedFrom: ISODateTimeString
  grantedTo: ISODateTimeString
  occuredAt: ISODateTimeString
}
